module.exports = __webpack_public_path__ + "img/earth.3d1521df.png";